(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-us"] && !Shopify.designMode) return;
  try {
    
      const contact_form_button = document.querySelector('#contact_form_button');
      const contact_page = document.querySelector('#contact-page');
      contact_form_button.addEventListener('click', function () {
        contact_page.classList.toggle('hidden');
      });
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-new"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobile = window.matchMedia('(max-width: 1023.98px)');
    let inerted = [];

    const burgerFor = (nav) => document.querySelector(`[data-site-nav-open][aria-controls="${nav.id}"]`);

    // Everything outside the open drawer: every sibling of every ancestor up to <body>.
    const inertOutside = (nav) => {
      for (let el = nav; el.parentElement && el !== document.body; el = el.parentElement) {
        for (const sibling of el.parentElement.children) {
          if (sibling === el || sibling.inert || sibling.matches('script, style, link')) continue;
          sibling.inert = true;
          inerted.push(sibling);
        }
      }
    };

    const releaseInert = () => {
      inerted.forEach((el) => (el.inert = false));
      inerted = [];
    };

    const setScreen = (nav, toggle, open, moveFocus = true) => {
      const screen = document.getElementById(toggle.getAttribute('aria-controls'));
      // A screen's content can ship in a <template> (site-nav-country): insert it on first open.
      if (open) {
        screen.querySelectorAll('template[data-lazy-template]').forEach((template) => {
          template.replaceWith(template.content.cloneNode(true));
        });
      }
      screen.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      nav.toggleAttribute('data-level2', open);
      if (!moveFocus) return;
      if (open) screen.querySelector('[data-screen-back]')?.focus();
      else toggle.focus();
    };

    const openNav = (nav) => {
      if (nav.hasAttribute('data-open')) return;
      nav.setAttribute('data-open', '');
      nav.setAttribute('role', 'dialog');
      nav.setAttribute('aria-modal', 'true');
      nav.setAttribute('aria-label', nav.dataset.dialogLabel);
      burgerFor(nav)?.setAttribute('aria-expanded', 'true');
      inertOutside(nav);
      document.body.classList.add('overflow-hidden');
      nav.querySelector('.site-nav__bar [data-site-nav-close]')?.focus();
    };

    const closeNav = (nav, restoreFocus = true) => {
      if (!nav.hasAttribute('data-open')) return;
      nav.querySelectorAll('[data-screen-toggle][aria-expanded="true"]').forEach((toggle) => {
        setScreen(nav, toggle, false, false);
      });
      // blocks/menu-item.liquid closes its open panel on this.
      document.dispatchEvent(new CustomEvent('site-nav:close'));
      nav.removeAttribute('data-open');
      nav.removeAttribute('data-level2');
      nav.removeAttribute('role');
      nav.removeAttribute('aria-modal');
      nav.removeAttribute('aria-label');
      burgerFor(nav)?.setAttribute('aria-expanded', 'false');
      releaseInert();
      document.body.classList.remove('overflow-hidden');
      if (restoreFocus) burgerFor(nav)?.focus();
    };

    document.addEventListener('click', (event) => {
      const burger = event.target.closest('[data-site-nav-open]');
      if (burger) {
        const nav = document.getElementById(burger.getAttribute('aria-controls'));
        if (nav) openNav(nav);
        return;
      }

      const nav = event.target.closest('[data-site-nav]');
      if (!nav) return;

      if (event.target.closest('[data-site-nav-close]')) {
        closeNav(nav);
        return;
      }

      const screenToggle = event.target.closest('[data-screen-toggle]');
      if (screenToggle) {
        setScreen(nav, screenToggle, true);
        return;
      }

      const back = event.target.closest('[data-screen-back]');
      if (back) {
        const screen = back.closest('[data-site-nav-screen]');
        const toggle = nav.querySelector(`[data-screen-toggle][aria-controls="${screen.id}"]`);
        if (toggle) setScreen(nav, toggle, false);
        return;
      }

      // The menu makes the page inert, so close it before handing over to the search drawer.
      if (event.target.closest('[data-site-nav-search]')) {
        closeNav(nav, false);
        const searchToggle = document.querySelector('.header-actions [data-drawer-target="Header-search-drawer"]');
        searchToggle?.focus();
        searchToggle?.click();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || event.defaultPrevented) return;
      const nav = document.querySelector('[data-site-nav][data-open]');
      if (!nav) return;
      const screenToggle = nav.querySelector('[data-screen-toggle][aria-expanded="true"]');
      if (screenToggle) {
        event.preventDefault();
        setScreen(nav, screenToggle, false);
        return;
      }
      // An open menu panel is closed by blocks/menu-item.liquid's own Escape handler.
      if (nav.querySelector('.menu-item__toggle[aria-expanded="true"]')) return;
      closeNav(nav);
    });

    mobile.addEventListener('change', () => {
      document.querySelectorAll('[data-site-nav][data-open]').forEach((nav) => closeNav(nav, false));
      document.dispatchEvent(new CustomEvent('site-nav:close'));
    });

    // Theme editor: selecting a menu item at mobile width opens the drawer at that item.
    document.addEventListener('shopify:block:select', (event) => {
      if (!mobile.matches) return;
      const nav = event.target.closest('[data-site-nav]');
      if (nav) openNav(nav);
    });

    // The editor re-renders the section: drop the inert/scroll lock held for the old DOM.
    document.addEventListener('shopify:section:unload', (event) => {
      const nav = event.target.querySelector('[data-site-nav][data-open]');
      if (nav) closeNav(nav, false);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
